"use strict";

exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hoc-expandable/~/recompose/setStatic.js
 ** module id = 490
 ** module chunks = 1
 **/